import {
  ApartmentOutlined,
  AppstoreOutlined,
  FileOutlined,
  PushpinOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { isAllowedService } from "../../../utils/services";

const HubSidebar = ({ hubId }): ReactElement => {
  const pathname = window.location?.pathname;

  return (
    <>
      <div className="h-100 product-details-wrapper-content">
        <div className="aside-menu">
          <Menu
            defaultSelectedKeys={["0"]}
            // defaultOpenKeys={['sub1']}
            mode="inline"
          >
            <Menu.Item
              key="details"
              className={
                pathname.includes(`hubs/${hubId}/details`) ? "active" : ""
              }
              icon={<ShopOutlined />}
            >
              <Link to={`/hubs/${hubId}/details`}>Hub Information</Link>
            </Menu.Item>

            <Menu.Item
              key="shops"
              icon={<ShoppingCartOutlined />}
              className={pathname.includes("/shops") ? "active" : ""}
            >
              <Link to={`/hubs/${hubId}/shops`}>Shop Management</Link>
            </Menu.Item>

            {isAllowedService(`Order List`) && (
              <Menu.Item
                key="orders"
                icon={<FileOutlined />}
                className={pathname.includes("/orders") ? "active" : ""}
              >
                <Link to={`/hubs/${hubId}/orders`}>Order Management</Link>
              </Menu.Item>
            )}

            <Menu.Item
              key="categories"
              icon={<ApartmentOutlined />}
              className={pathname.includes("/categories") ? "active" : ""}
            >
              <Link to={`/hubs/${hubId}/categories`}>Category Management</Link>
            </Menu.Item>

            <Menu.Item
              key="/products"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/products") ? "active" : ""}
            >
              <Link to={`/hubs/${hubId}/products`}>Product Management</Link>
            </Menu.Item>
            <Menu.Item
              key="/campaigns"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/campaigns") ? "active" : ""}
            >
              <Link to={`/hubs/${hubId}/campaigns`}>Campaign</Link>
            </Menu.Item>
            <Menu.Item
              key="/brands"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/brands") ? "active" : ""}
            >
              <Link to={`/hubs/${hubId}/brands`}>Brand</Link>
            </Menu.Item>

            <Menu.Item
              key="areas"
              icon={<PushpinOutlined />}
              className={pathname.includes("/areas") ? "active" : ""}
            >
              <Link to={`/hubs/${hubId}/areas`}>Area Management</Link>
            </Menu.Item>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default HubSidebar;
